import { makeStyles } from '@material-ui/core/styles'
import { calcMargin } from '@v4/utils/theme'

const useStyles = makeStyles(
	theme => ({
		text: {
			marginBottom: theme.spacing(4.75),

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},
		additionalText: {
			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},
		buttonWrap: {
			display: 'flex',
			justifyContent: 'flex-start',

			[theme.breakpoints.down('xs')]: {
				justifyContent: ({ metaData }) => metaData.mobileAlignment?.contentAlignment(),
			},
		},
		button: {
			marginBottom: theme.spacing(1.5),

			[theme.breakpoints.down('xs')]: {
				width: ({ metaData }) => (metaData.mobileButtonWidth?.isWide ? '100%' : 'auto'),
			},
		},
		imageWrap: {
			position: 'relative',
		},

		content: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'stretch',
			maxWidth: ({ isMobile }) => (isMobile ? '100%' : theme.spacing(61)),
			transition: theme.transitions.create(['padding-top', 'padding-bottom']),
			paddingTop: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isLeftAlignment) {
					return null
				}
				const marginMeta = metaData.overrideXsMargins?.toBoolean() ? metaData.xsMarginTop : metaData.marginTop

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.top,
					isMobile: true,
				})
			},
			paddingBottom: ({ metaData, isMobile, minMargins }) => {
				if (!isMobile || !metaData.mobileImagePosition?.isRightAlignment) {
					return null
				}

				const marginMeta = metaData.overrideXsMargins?.toBoolean()
					? metaData.xsMarginBottom
					: metaData.marginBottom

				return calcMargin({
					spacing: theme.spacing,
					value: marginMeta?.metaValue,
					minMargin: minMargins.bottom,
					isMobile: true,
				})
			},
		},
		image: {
			'& picture': {
				display: 'flex',
				justifyContent: 'center',
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'contain',
			},
		},

		desktopImageText: {
			position: 'absolute',
			width: '100%',
			bottom: 0,
			height: 'auto',
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			zIndex: 1,
			padding: theme.spacing(2.75, 3.75),
		},

		mobileImageText: {
			position: 'absolute',
			width: '100%',
			bottom: 0,
			height: 'auto',
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			padding: theme.spacing(2.75, 3.75),
			zIndex: 1,

			[theme.breakpoints.down('sm')]: {
				textAlign: ({ metaData }) => metaData.mobileAlignment?.metaValue,
			},
		},
		mobileImage: {
			'& picture': {
				maxHeight: theme.spacing(80),
			},
			'& img': {
				objectPosition: 'center',
				objectFit: 'cover',
			},
			marginBottom: theme.spacing(3),
		},
		mobileImageWrap: {
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
		},
	}),
	{ name: 'CallToAction-Cta15' },
)

export default useStyles
